import { ActionTree, Action } from 'vuex';
import { IndividuState, INDIVIDUS_STORE as s } from './type';
import { RootState, SHOW_LOADING, CLOSE_LOADING } from '@/store/types';
import router from '@/router';
import { Individu } from '@/models/Individu';
import { HistoScolarite } from '@/models/HistoScolarite';
import { Pointage } from '@/models/Pointage';
import { utils } from '@/util';
import { NiveauScolaireDocument } from '@/models/NiveauScolaireDocument';
import { Ville } from '@/models/Ville';
import { PaletteDocument } from '@/models/PaletteDocument';
import { Activite } from '@/models/Activite';
import { Etablissement } from '@/models/Etablissement';
import { Inscription } from '@/models/Inscription';
import db from "@/db";
import { Parent } from '@/models/Parent';
import { PointageInoeDocument } from '@/models/PointageInoeDocument';
import { PointageDetailInoeDocument } from '@/models/PointageDetailInoeDocument';
import { ClasseScolaireDocument } from '@/models/ClasseScolaireDocument';
import { EtablissementScolaireDocument } from '@/models/EtablissementScolaireDocument';
import { EnseignantScolaireDocument } from '@/models/EnseignantScolaireDocument';
import { AnneeScolaireDocument } from '@/models/AnneeScolaireDocument';
import { User } from '@/models/User';
import { TarifEventSchedulerActiviteDocument } from '@/models/TarifEventSchedulerActiviteDocument';
import { TarifActiviteDocument } from '@/models/TarifActiviteDocument';
import { Supplement } from '@/models/Supplement';


export const fetchListIndividus: Action<IndividuState, RootState> = ({ commit, rootGetters, state, dispatch }, params: string) => {
    return new Promise((resolve, reject) => {
        let currentUser = rootGetters.getCurrentUser;
        let listIndividus: Array<Individu> = [];
        let currentEtab = rootGetters.getCurrentEtablissement as Etablissement;
        if (params === 'activite') {
            let currentActivite = rootGetters.getCurrentActivite;
            let activiteInscription = currentActivite.getInscriptions();
            activiteInscription.forEach((inscription: Inscription) => {
                if (!inscription.isNoninscrit()) {
                    let ind = inscription.getIndividu();
                    if (ind != null){
                        ind.setListeAutorisations(ind.getAutori(currentEtab.getId()));
                        listIndividus.push(ind);
                    }
                }
            });
        } else {
            let listActivite = (currentEtab as Etablissement).getActivites().filter((activite: Activite) => (currentUser.activities as Array<number>).includes(activite.getId()));
            let now = utils.getCurrentTimeNow();
            listActivite.forEach((activite: Activite) => {
                if (state.filtreIndividusJour) {
                    if (activite.getJours().toLowerCase().includes(now.format('dddd').slice(0, 2))) {
                        let activiteInscription = activite.getInscriptions();
                        activiteInscription.forEach((inscription: Inscription) => {
                            if (!inscription.isNoninscrit()) {
                                let ind = inscription.getIndividu();
                                if (ind != null){
                                    ind.setListeAutorisations(ind.getAutori(currentEtab.getId()));
                                    listIndividus.push(ind);
                                }
                            }
                        });
                    }
                } else {
                    let activiteInscription = activite.getInscriptions();
                    activiteInscription.forEach((inscription: Inscription) => {
                        if (!inscription.isNoninscrit()) {
                            let ind = inscription.getIndividu();
                            ind.setListeAutorisations(ind.getAutori(currentEtab.getId()));
                            listIndividus.push(ind);
                        }
                    });

                }

            });
        }
        //Retirer les doublons
        let ordered = listIndividus
            .filter((thing, index, self) =>
                index === self.findIndex((t) => (
                    t.getId() === thing.getId()
                )))
            .sort(((a: Individu, b: Individu) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getDisplayName(), b.getDisplayName())));

        commit(s.SET_LIST_INDIVIDUS, ordered);
        commit(s.SET_FILTRED_LIST_INDIVIDUS, ordered);
        resolve('done')

    })
};
export const fetchDataForFilter: Action<IndividuState, RootState> = ({ dispatch }) => {
    return new Promise((resolve, reject) => {
        let listPromise: Array<Promise<any>> = [];
        listPromise.push(dispatch('fetchListClasses'));
        listPromise.push(dispatch('fetchListEcoles'));
        listPromise.push(dispatch('fetchListInstits'));
        listPromise.push(dispatch('fetchListHisto'));
        listPromise.push(dispatch('fetchListNiveau'));
        listPromise.push(dispatch('fetchListVille'));
        listPromise.push(dispatch('fetchCurrentAnneeScolaire'));
        listPromise.push(dispatch('fetchEtablissementScolaireNiveau'));
        listPromise.push(dispatch('fetchClasseScolaireNiveau'));
        listPromise.push(dispatch('fetchClasseScolaireEnseignant'));
        Promise.all(listPromise).then((response: any) => {
            resolve('done')
        }).catch((error: any) => console.error(error));
    })

};
export const fetchTousIndividus: Action<IndividuState, RootState> = ({ commit, dispatch }, params: boolean) => {
    dispatch(SHOW_LOADING, null, { root: true });
    commit(s.SET_LIST_INDIVIDUS, new Array());
    commit(s.SET_FILTRED_LIST_INDIVIDUS, new Array());
    setTimeout(() => {
        commit(s.SET_INDIVIDU_DU_JOUR, params);
        dispatch("fetchListIndividus").then(() => dispatch(CLOSE_LOADING, null, { root: true }))
    }, 500);

};
export const fetchListClasses: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listClasses !== 'undefined' && state.listClasses.length !== 0) {
            resolve('done');
            return;
        }
        let listClass = db.listClasses();
        if (typeof listClass !== 'undefined' && Array.isArray(listClass)) {
            commit(s.SET_LIST_CLASSES, listClass.sort((a: ClasseScolaireDocument, b: ClasseScolaireDocument) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getNom(), b.getNom()))
            );
        }
        resolve('done')

    })
};
export const fetchListEcoles: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listEcoles !== 'undefined' && state.listEcoles.length !== 0) {
            resolve('done');
            return;
        }
        let listEcoles = db.listEcoles();
        if (typeof listEcoles !== 'undefined' && Array.isArray(listEcoles)) {
            commit(s.SET_LIST_ECOLES, listEcoles.sort((a: EtablissementScolaireDocument, b: EtablissementScolaireDocument) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getNom(), b.getNom()))
            );
        }
        resolve('done')

    })
};
export const fetchListInstits: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listInstits !== 'undefined' && state.listInstits.length !== 0) {
            resolve('done');
            return;
        }
        let listInstit = db.listInstit();
        if (typeof listInstit !== 'undefined' && Array.isArray(listInstit)) {
            commit(s.SET_LIST_INSTITS, listInstit.sort((a: EnseignantScolaireDocument, b: EnseignantScolaireDocument) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getNom(), b.getNom())))
        }
        resolve('done')

    })
};
export const fetchListHisto: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listHisto !== 'undefined' && state.listHisto.length !== 0) {
            resolve('done');
            return;
        }
        commit(s.SET_LIST_HISTO, db.HistoScolarite())
        resolve('done')
    })
};

export const fetchCurrentAnneeScolaire: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.currentAnneeScolaire !== 'undefined' && Object.keys(state.currentAnneeScolaire).length !== 0) {
            resolve('done');
            return;
        }
        let currentAnneeScolaire = db.currentAnneeScolaire();
        if (typeof currentAnneeScolaire !== 'undefined') {
            commit(s.SET_CURRENT_ANNEE_SCOLAIRE, currentAnneeScolaire);
        }
        resolve('done')


    })
};
export const fetchListNiveau: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listNiveau !== 'undefined' && state.listNiveau.length !== 0) {
            resolve('done');
            return;
        }
        let listNiveau = db.listNiveau();
        if (typeof listNiveau !== 'undefined' && Array.isArray(listNiveau)) {
            commit(s.SET_LIST_NIVEAU, listNiveau.sort((a: NiveauScolaireDocument, b: NiveauScolaireDocument) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getIntitule(), b.getIntitule())))
        }
        resolve('done')

    })
};

export const fetchEtablissementScolaireNiveau: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listEtablissementScolaireNiveau !== 'undefined' && state.listEtablissementScolaireNiveau.length !== 0) {
            resolve('done');
            return;
        }
        let listEtabScolaireNiveau = db.listEtablissementScolaireNiveau();
        commit(s.SET_ETABLISSEMENT_SCOLAIRE_NIVEAU, listEtabScolaireNiveau)
        resolve('done')
    })
};

export const fetchClasseScolaireNiveau: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listClasseScolaireNiveau !== 'undefined' && state.listClasseScolaireNiveau.length !== 0) {
            resolve('done');
            return;
        }
        let listClasseScolaireNiveau = db.listClasseScolaireNiveau();
        commit(s.SET_CLASSE_SCOLAIRE_NIVEAU, listClasseScolaireNiveau)
        resolve('done')
    })
};

export const fetchClasseScolaireEnseignant: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listClasseScolaireEnseignant !== 'undefined' && state.listClasseScolaireEnseignant.length !== 0) {
            resolve('done');
            return;
        }
        let listClasseScolaireEnseignant = db.listClasseScolaireEnseignant();
        commit(s.SET_CLASSE_SCOLAIRE_ENSEIGNANT, listClasseScolaireEnseignant);
        resolve('done')
    })
};

export const fetchListVille: Action<IndividuState, RootState> = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        if (typeof state.listVille !== 'undefined' && state.listVille.length !== 0) {
            resolve('done');
            return;
        }
        let listVille = db.listVille();
        if (typeof listVille !== 'undefined' && Array.isArray(listVille)) {
            commit(s.SET_LIST_VILLE, listVille.sort((a: Ville, b: Ville) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getVilleintitule(), b.getVilleintitule())))
        }
        resolve('done')
    })
};


export const filtreListIndividus: Action<IndividuState, RootState> = async ({ commit, state, rootGetters, dispatch }, params) => {

    let filtred: Array<Individu> = Array.from(state.listIndividus);
    let currentAnneeScolaire = state.currentAnneeScolaire as AnneeScolaireDocument;
    if (params) {
        commit(s.SET_FILTRE_ACTIFS, params)
    }

    //Filtres actifs
    if (state.filtreAge.actif) {
        let current = utils.getCurrentTimeNow();
        filtred = filtred.filter((item: Individu) => {
            let dateNaissance = utils.getDateFromString(item.getDatenaissance(), "YYYY-MM-DD")
            let y = current.diff(dateNaissance, 'years');
            if (y >= state.filtreAge.value.ageMin && y <= state.filtreAge.value.ageMax) {
                return item;
            }
        })
    }
    if (state.filtreEcoles.actif) {
        filtred = filtred.filter((item: Individu) => {
            let histoIndividu = item.getHistoScolariteIndividu();
            //Avoir uniquement l'Histo de l'année scolaire en cours
            histoIndividu = histoIndividu.filter((h: HistoScolarite) =>
                h.getAnneescolaire_id() === currentAnneeScolaire.getId());
            let isFound = false;
            histoIndividu.forEach((histo: HistoScolarite) => {
                let ecole = histo.getEtablissementScolaire();
                if (typeof ecole !== 'undefined' && state.filtreEcoles.value.includes(ecole.getId()))
                    isFound = true;
            });
            if (isFound)
                return item;
        })
    }
    if (state.filtreClasses.actif) {
        filtred = filtred.filter((item: Individu) => {
            let histoIndividu = item.getHistoScolariteIndividu();
            //Avoir uniquement l'Histo de l'année scolaire en cours
            histoIndividu = histoIndividu.filter((h: HistoScolarite) =>
                h.getAnneescolaire_id() === currentAnneeScolaire.getId());
            let isFound = false;
            histoIndividu.forEach((histo: HistoScolarite) => {
                let classe = histo.getClasseScolaire();
                if (typeof classe !== 'undefined' && state.filtreClasses.value.includes(classe.getId()))
                    isFound = true;
            });
            if (isFound)
                return item;
        })
    }
    if (state.filtreNiveau.actif) {
        filtred = filtred.filter((item: Individu) => {
            let histoIndividu = item.getHistoScolariteIndividu();
            //Avoir uniquement l'Histo de l'année scolaire en cours
            histoIndividu = histoIndividu.filter((h: HistoScolarite) =>
                h.getAnneescolaire_id() === currentAnneeScolaire.getId());
            let isFound = false;
            histoIndividu.forEach((histo: HistoScolarite) => {
                let niveau = histo.getNiveauScolaire();
                if (typeof niveau !== 'undefined' && state.filtreNiveau.value.includes(niveau.getId()))
                    isFound = true;
            });
            if (isFound)
                return item;
        })
    }
    if (state.filtreInstit.actif) {
        filtred = filtred.filter((item: Individu) => {
            let histoIndividu = item.getHistoScolariteIndividu();
            //Avoir uniquement l'Histo de l'année scolaire en cours
            histoIndividu = histoIndividu.filter((h: HistoScolarite) =>
                h.getAnneescolaire_id() === currentAnneeScolaire.getId());
            let isFound = false;
            histoIndividu.forEach((histo: HistoScolarite) => {
                let enseignant = histo.getEnseignant();
                if (typeof enseignant !== 'undefined' && state.filtreInstit.value.includes(enseignant.getId()))
                    isFound = true;
            });
            if (isFound)
                return item;
        })
    }
    if (state.filtrePointage.actif) {
        let palettePresence = Array.from(rootGetters.getListPalettePresence) as Array<PaletteDocument>;
        let paletteAbsences = Array.from(rootGetters.getListPaletteAbsence) as Array<PaletteDocument>;

        let listTempsAccueilFiltred = Array.from(rootGetters.getListTempsAccueilFiltred as Array<TarifEventSchedulerActiviteDocument>);
        /* let listSupplementsFiltred = Array.from(rootGetters.getListSupplementsFiltred as Array<TarifActiviteDocument>);*/

        let listPointagesActif: Array<Pointage> = Array.from(rootGetters.getPointageEnCours);
        let listPointagesPrevi: Array<any> = Array.from(rootGetters.getListPointagesPrevi);
        /* let listSupplementsActif: Array<Supplement> = Array.from(rootGetters.getSupplementsActifs);
            let listSupplementPrevi: Array<any> = Array.from(rootGetters.getListSupplementsPrevi);*/


        let filtredPointagesActif: Array<Pointage> = new Array();
        let filtredPointagesPrevi: Array<any> = new Array();
        /* let filtredSupplementsActif: Array<Supplement> = new Array();
            let filtredSupplementsPrevi: Array<any> = new Array();*/

        filtredPointagesActif = listPointagesActif.filter((poActif: Pointage) => {
            if (typeof poActif.getElementFriseId() !== 'undefined'
                && poActif.getElementFriseId() !== -1
                && listTempsAccueilFiltred.some((temps: TarifEventSchedulerActiviteDocument) =>
                    temps.getFriseElement_id() === poActif.getElementFriseId()))
                return poActif;

            else if (typeof poActif.getTempsSupplementaireId() !== 'undefined'
                && poActif.getTempsSupplementaireId() !== -1
                && listTempsAccueilFiltred.some((temps: TarifEventSchedulerActiviteDocument) =>
                    temps.getTempsTarif_id() === poActif.getTempsSupplementaireId()))
                return poActif;
        })

        filtredPointagesPrevi = listPointagesPrevi.filter((previ: any) => {
            if (typeof previ.elementfrise_id !== 'undefined'
                && listTempsAccueilFiltred.some((temps: TarifEventSchedulerActiviteDocument) =>
                    temps.getFriseElement_id() === previ.elementfrise_id))
                return previ;
            else if (typeof previ.tariftempssupplactivite_id !== 'undefined'
                && listTempsAccueilFiltred.some((temps: TarifEventSchedulerActiviteDocument) =>
                    temps.getTempsTarif_id() === previ.tariftempssupplactivite_id))
                return previ;
        })

        let indIdPointageActif = new Set(filtredPointagesActif.map((pointage: Pointage) => pointage.getIdIndividu()));
        let indIdPointagePrevi = new Set(filtredPointagesPrevi.map((pointPrevi: any) => pointPrevi.individu_id));
        //let indIdSupplementPrevi = new Set(listSupplementPrevi.map((supPrevi: any) => supPrevi.individu_id));


        switch (state.filtrePointage.value) {
            case 'rien': {
                filtred = filtred.filter((item: Individu) => {
                    if (!indIdPointageActif.has(item.getId())) {
                        return item;
                    }
                })
                break;
            }
            case 'sans_pointage': {
                filtred = filtred.filter((item: Individu) => {
                    if (!indIdPointageActif.has(item.getId()) &&
                        !indIdPointagePrevi.has(item.getId())) {
                        //&& !indIdSupplementPrevi.has(item.getId())) {
                        return item;
                    }
                })
                break;
            }
            case 'previ': {
                filtred = filtred.filter((item: Individu) => {
                    if (indIdPointagePrevi.has(item.getId())) {
                        //|| indIdSupplementPrevi.has(item.getId())) {
                        return item;
                    }
                })
                break;
            }
            case 'present': {
                filtred = filtred.filter((item: Individu) => {
                    if (filtredPointagesActif.some((point: Pointage) => point.getIdIndividu() === item.getId() &&
                        palettePresence.some((palette: PaletteDocument) => palette.getId() === point.getPaletteId()))) {
                        return item;
                    }
                })
                break;
            }
            case 'absent': {
                filtred = filtred.filter((item: Individu) => {
                    if (filtredPointagesActif.some((point: Pointage) => point.getIdIndividu() === item.getId() &&
                        paletteAbsences.some((palette: PaletteDocument) => palette.getId() === point.getPaletteId()))) {
                        return item;
                    }
                })
                break;
            }
            case 'orphelin': {
                filtred = filtred.filter((item: Individu) => {
                    if (filtredPointagesActif.some((point: Pointage) => point.getIdIndividu() === item.getId() &&
                        point.getTempsFin().length < 1)) {
                        return item;
                    }
                })
                break;
            }
            default:
                break;
        }
    }
    if (state.filtreGroupes.actif) {
        let currentActivite = rootGetters.getCurrentActivite as Activite;
        let date: string
        currentActivite.getPointage() === "EN_HORAIRE"
            ? date = utils.getCurrentTimeNow().format("YYYY-MM-DD")
            : date = utils.getDateFromString(rootGetters.getDate, "YYYY-MM-DD");
        filtred = filtred.filter((item: Individu) => {
            let inscription = item.getInscriptionActivite(currentActivite.getId()) as Inscription | undefined
            let groupeIntitule: string;
            let hasGroupeReservation: boolean = false
            let hasSelectedGroupe: boolean = false
            if (typeof inscription !== 'undefined') {
                //Récuperer les groueps à partir des reservations s'il en existe
                inscription.getPointagesPrev().forEach((pointage: PointageInoeDocument) => {
                    pointage.getPointagesDetails().forEach((pointageDetail: PointageDetailInoeDocument) => {
                        try {
                            groupeIntitule = pointageDetail.getGroupeActivite().getGroupeIndividu().getintitule()
                            hasGroupeReservation = true
                            if (state.filtreGroupes.value.includes(groupeIntitule)) {
                                hasSelectedGroupe = true
                            }
                        } catch (error) {
                            console.error(error)
                        }
                    });
                });

                if (hasSelectedGroupe)
                    return item;
                else if (!hasGroupeReservation)
                    try {
                        groupeIntitule = inscription.getHistoGroupe(date).getGroupeActivite().getGroupeIndividu().getintitule()
                        if (state.filtreGroupes.value.includes(groupeIntitule)) {
                            return item;
                        }
                    } catch (error) {
                        console.error(error)
                    }
            }
        })
    }
    if (state.filtreRegim.actif) {
        filtred = filtred.filter((item: Individu) => {
            if (state.filtreRegim.value.includes(item.getRegimeAlimentaireIndividu().getVieQuoRegimeAli().getType_regime()))
                return item
        })
    }
    if (state.filtreVille.actif) {
        filtred = filtred.filter((item: Individu) => {
            let listParents = item.getListeParents();
            if (listParents.some((parent: Parent) =>
                state.filtreVille.value.includes(parent.getVille()))) {
                return item;
            }
        })
    }

    if (filtred.length !== 0) {
        if (state.filtrePrenom) {
            filtred.forEach((item: Individu) => {
                item.setDisplayName(item.getPrenom() + " " + item.getNom())
            });
        } else {
            filtred.forEach((item: Individu) => {
                item.setDisplayName(item.getNom() + " " + item.getPrenom())
            });
        }
        filtred = filtred.sort(((a: Individu, b: Individu) =>
            new Intl.Collator('fr', { usage: "sort" }).compare(a.getDisplayName(), b.getDisplayName())));
    }
    commit(s.SET_FILTRED_LIST_INDIVIDUS, filtred);
    if (filtred.length !== state.listIndividus.length)
        dispatch("pointages/fetchIndividusFiltreesPresents", null, { root: true });

};
export const closeFiltre: Action<IndividuState, RootState> = ({ commit, dispatch }, filtre: string) => {
    commit(s.SET_FILTRE_CLOSE, filtre);
    dispatch('filtreListIndividus')
};

export const selectIndividu: Action<IndividuState, RootState> = ({ commit }, ind: Individu) => {
    commit(s.SET_INDIVIDU, ind);
    router.push({ path: `/information/${ind.getId()}` })
};
export const actions: ActionTree<IndividuState, RootState> = {
    fetchListIndividus,
    filtreListIndividus,
    closeFiltre,
    selectIndividu,
    fetchDataForFilter,
    fetchListClasses,
    fetchListEcoles,
    fetchListNiveau,
    fetchListHisto,
    fetchListInstits,
    fetchListVille,
    fetchCurrentAnneeScolaire,
    fetchEtablissementScolaireNiveau,
    fetchClasseScolaireNiveau,
    fetchClasseScolaireEnseignant,
    fetchTousIndividus
}
